import { isClub, isSoloare, JsEnv, SiteType } from '../../core/models/js_env';
import { ArrivalContactReceptionRepository } from '../../core/repositories/currentsystem/club/arrival_contact_reception_repository'
import { ArrivalContactMailRegister } from '../../core/repositories/currentsystem/soloare/arrival_contact_email_register_repository'
import { TypedEvent } from '../../core/typed_event';
import { AddressChoiceModel } from '../models/item_js_env';
import { ItemKey } from '../../core/models/currentsystem/soloare/item_key';
import { OrderClosingDateTimeRepository } from '../../core/repositories/stock_display/OrderClosingDateTimeRepository';
import { StockAddressUpdateRepository } from '../../core/repositories/currentsystem/club/club_stock_address_update_repositoy';
import { DeliveryUpdateRepository } from '../../core/repositories/currentsystem/soloare/soloare_delivery_update_repository';
import RedirectUtil from "../../core/util/redirect_util";
import { Env } from "../../core/env";

// お届け先住所選択値
const ZIP_INDEX = 0;
const AREA_CODE_A_INDEX = 1;
const AREA_CODE_B_INDEX = 2;
const ADRESS_1_INDEX = 3;
const ADRESS_2_1_INDEX = 4;
const ADRESS_2_2_INDEX = 5;
const ADRESS_3_INDEX = 6;
const ADRESS_ID_INDEX = 7;

const inputStockNum = (inputQuantityElement: HTMLInputElement) => {
  let stockNum = inputQuantityElement.value || "";

  //  数量 最大文字数設定
  if (stockNum.length > inputQuantityElement.maxLength) {
    // firefoxの場合は、maxLengthが制限しないので、sliceで３桁以上の入力防止できる
    stockNum = stockNum.slice(0, inputQuantityElement.maxLength);
  }
  // firefoxの場合は、数字以外が入力される場合は""となりますので、inputセットで数字以外の入力防止できる
  inputQuantityElement.value = stockNum;

  //「在庫状況を反映する」ボタン活性／非活性制御
  const confirm: HTMLButtonElement = <HTMLButtonElement>document.querySelector('.js-stock-submitBtn');

  const hopeQuantity: string = (document.querySelector('#hopeQuantity') as HTMLInputElement)?.value ?? "1";

  confirm.disabled = (stockNum === hopeQuantity) || !stockNum || Number(stockNum) <= 0;
}

export class StockAreaAction {

    static readonly STOCK_DISPLAY_UPDATE_EVENT = new TypedEvent<AddressChoiceModel>();

    private static stockAddressUpdateRepository: StockAddressUpdateRepository;
    private static deliveryUpdateRepository: DeliveryUpdateRepository;
    private static orderClosingDateTimeRepository: OrderClosingDateTimeRepository;
    private static arrivalContactReceptionRepository: ArrivalContactReceptionRepository;
    private static arrivalContactMailRegisterRepository: ArrivalContactMailRegister;
    private static siteType: SiteType;
    private static now: Date;

    static init(env: JsEnv) {
        /// repository を初期化
        this.stockAddressUpdateRepository = new StockAddressUpdateRepository();
        this.deliveryUpdateRepository = new DeliveryUpdateRepository();
        this.orderClosingDateTimeRepository = new OrderClosingDateTimeRepository();
        this.arrivalContactReceptionRepository = new ArrivalContactReceptionRepository();
        this.arrivalContactMailRegisterRepository = new ArrivalContactMailRegister();
        this.siteType = env.SITE_TYPE;
        this.now = new Date();
        this.readStockQuantityConfirmModal();
    }

    /// お届け先住所選択リストのプルダウンから選択
    static async deliveryDestinationAddressChoice(
        deliveryDestinationAddress: string,
    ) {
        const deliveryDestinationAddressList = deliveryDestinationAddress.split('_');
        let hasError = false;
        if (isClub(StockAreaAction.siteType)) {
            const zip = deliveryDestinationAddressList[ZIP_INDEX]
            const zip1 = zip.slice(0, 3) // 郵便: 1234567 -> 123
            const zip2 = zip.slice(3) // 郵便: 1234567 -> 4567
            // clubの場合
            // 在庫表示用住所変更APIを呼び出す
            await this.stockAddressUpdateRepository.updateStockAddress(
                zip1,
                zip2,
                deliveryDestinationAddressList[AREA_CODE_A_INDEX],
                deliveryDestinationAddressList[AREA_CODE_B_INDEX],
                deliveryDestinationAddressList[ADRESS_1_INDEX],
                deliveryDestinationAddressList[ADRESS_2_1_INDEX],
                deliveryDestinationAddressList[ADRESS_2_2_INDEX],
                deliveryDestinationAddressList[ADRESS_3_INDEX],
                deliveryDestinationAddressList[ADRESS_ID_INDEX]
            ).then((response) => {
                if (response && response.code != '00000') {
                    // レスポンスのステータスコード：200、結果コード：00000 以外の場合、下記のエラーメッセージを画面出力し、処理を終了する
                    alert('お届け先を変更できませんでした。画面を更新して、再度変更を行ってください。')
                    hasError = true;
                }
            });
        } else if (isSoloare(StockAreaAction.siteType)) {
            // ソロアリの場合
            // お届先変更APIを呼び出す
            await this.deliveryUpdateRepository.updateDelivery(
                this.now, // 現在日時
                deliveryDestinationAddressList[ADRESS_ID_INDEX]
            ).then((response) => {
                if (response && response.result !== "0") {
                    // レスポンスのステータスコード：200、結果コード：0 以外の場合、下記のエラーメッセージを画面出力し、処理を終了する
                    alert('お届け先を変更できませんでした。画面を更新して、再度変更を行ってください。')
                    hasError = true;
                }
            }).catch(() => {
                // レスポンスのステータスコード：200以外の場合、下記のエラーメッセージを画面出力し、処理を終了する
                alert('お届け先を変更できませんでした。画面を更新して、再度変更を行ってください。')
                hasError = true;
            });
        }

        if (!hasError) {
          // 現行サイトと同様、住所更新成功した場合、ヘッダーのお届け住所も更新するように画面リロードする
          window.location.reload();
        }
    };

    // 入荷案内メール登録リンク押下
    static async stockArrivalGuideMailLink(
        supplierId: string,
        catalogItemCode: string,
        isLogin: boolean,
    ) {
        if (!isLogin) {
            RedirectUtil.toLoginPage()
            return
        }
        if (!window.confirm('商品の入荷時にご登録のメールアドレスにメールをお送りします。「商品入荷のお知らせ」一覧はマイページよりご確認いただけます。')) {
            return;
        }
        if (isClub(Env.SITE_TYPE)) {
            // club の場合
            // 入荷連絡受付APIを実行する
            this.arrivalContactReceptionRepository.callArrivalContactReception(
                catalogItemCode
            ).then((response) => {
                if (response && response.code != '00000') {
                    // エラーのときにモーダル表示する(alert)
                    alert(response.message)
                }
            })
        } else if (isSoloare(StockAreaAction.siteType)) {
            // ソロアリの場合
            // 入荷連絡メール登録用APIを実行する
            const itemKeys = [new ItemKey(supplierId, catalogItemCode)]
            this.arrivalContactMailRegisterRepository.insertArrivalContactMail(
                this.now,
                itemKeys
            ).then((response) => {
                if (response && response.result !== '0') {
                    // エラーのときにモーダル表示する(alert)
                    alert(response.message)
                }
            })
        }
    }

    // 描画処理
    static async render(model: AddressChoiceModel, resultHtml: string) {
        StockAreaAction.STOCK_DISPLAY_UPDATE_EVENT.trigger({
            ...model,
            resultHtmlStr: resultHtml
        })
    }

    // 在庫確認モーダル読み込み処理
    static async readStockQuantityConfirmModal() {
        document.querySelector('#stockNum')?.addEventListener(
            'input',
            (event: Event) => {
                inputStockNum(event?.target as HTMLInputElement);
            }
        );

        return new StockQuantityConfirmModal();
    }

    // 在庫確認モーダル「在庫状況を反映する」クリック処理
    static async confirmStockQuantity(
        model: AddressChoiceModel
    ) {

        const quantity: string = (document.querySelector('#stockNum') as HTMLInputElement)!.value;

        const hopeQuantity: HTMLInputElement = <HTMLInputElement>document.querySelector('#hopeQuantity');

        if(hopeQuantity) {
            hopeQuantity!.value = quantity;
        }

        // Webフロントサーバの在庫エリア取得エンドポイントにリクエストを送信する
        const resultHtml = await this.orderClosingDateTimeRepository.getOrderClosingDateTime(
            model.supplierId,
            model.catalogItemCode,
            Number(quantity),
            (document.querySelector('#js-stock-delivery-address-pulldown') as HTMLSelectElement)?.value ?? "",
            false
        )

        // 返却されたHTMLを利用して再描画
        this.render(model, resultHtml);
        // common.jsのtooltip処理を実行
        const WindowTooltip = window._tooltip;
        new WindowTooltip(document.getElementById('js-m-shippinginfo-area')); // NOSONAR
        this.readStockQuantityConfirmModal();
    }
}

const CommonModal = (window as any)._modal;

class StockQuantityConfirmModal extends CommonModal {

    constructor() {
        super('data-stock-quantity-confirm-trigger');
    }

    // モーダル開閉時の処理
    onOpen(): boolean | void {
        // モーダル表示時は、在庫数の初期値を希望数量とする
        const inputStockElement = document.querySelector('#stockNum') as HTMLInputElement;
        const hopeQuantity: string = (document.querySelector('#hopeQuantity') as HTMLInputElement)?.value ?? "1";
        inputStockElement.value = hopeQuantity;
        inputStockNum(inputStockElement);
    }
}

